<template>
  <div class="modal is-clipped is-active" v-show="this.visible">
    <div class="modal-background"></div>
    <div class="modal-content">
      <img class="loader-img " src="@/assets/gears.svg" alt="Gears spinning while loading page">
    </div>
  </div>
</template>
<script>
export default {
  name: 'ccLoading',
  data () {
    return {
      visible: null
    }
  },
  methods: {
    show: function () {
      this.visible = true
    },
    hide: function () {
      this.visible = false
    }
  }
}
</script>
